import React from 'react';
import { Redirect } from 'react-router-dom';
import { I18NContext } from '../../I18NContext';
import { CancellationReasonFilterOption, Order } from '../component';
import CancelFormSelect from './CancelFormSelect';
import cancelOrder from '../../accessors/CancelOrderAccessor';
import { CancellationDropdown, CancellationDropdownItem } from './CancellationDropdown';

import appMetrics from '../../common/MetricsService';
import MetricsConstants from '../../common/MetricsConstants';
import * as KatalMetrics from '@amzn/katal-metrics';
import OrderHistoryRedirectionComponentRow from '../order/OrderHistoryRedirectionComponent'

interface CancelFormProps {
    order: Order;
    refresh?: () => void;
}

interface CancelFormState {
    selectorRef: React.RefObject<any>;
    disableButton: boolean;
    alert: any,
    cancelFilterOption?: CancellationReasonFilterOption
}

class CancelForm extends React.Component<CancelFormProps, CancelFormState> {

    constructor(props: any) {
        super(props);

        this.state = {
            selectorRef: React.createRef(),
            alert: false,
            disableButton: false,
            cancelFilterOption: undefined
        }
    }

    setCancelReason = (cancelFilterValue: string) => {
        let newOption;
        this.props.order.orderDetailPageLabels.cancelForm.cancelReason.cancelReasonFilterOptions.forEach(function(cancellationOption){
            if(cancelFilterValue === cancellationOption.value){
                newOption = cancellationOption;
            }
        })
        this.setState({
            cancelFilterOption: newOption
        });
    };

    render() {
        const cancelReason = this.props.order.orderDetailPageLabels.cancelForm.cancelReason;
        const showCancelDrop = cancelReason && cancelReason.cancelReasonFilterOptions;
        const button = this.state.disableButton || (showCancelDrop && !this.state.cancelFilterOption) ?
            <pui-button spacingTop='small' disabled onClick={() => this._onSubmit()} label={this.props.order.orderDetailPageLabels.cancelForm.cancelButton} /> :
            <pui-button id="button-to-cancel" data-csa-c-type="button" data-csa-c-action="cancel" data-csa-c-content-id="button-to-cancel" data-csa-c-slot-id="main"
                        spacingTop='small' onClick={() => this._onSubmit()} label={this.props.order.orderDetailPageLabels.cancelForm.cancelButton} />

        return (<pui-stack direction='vertical' mainAxisArrangement='start' secondaryAxisArrangement='start'
            flex="true">
            {this.state.alert}
            <pui-heading input={this.props.order.orderDetailPageLabels.cancelForm.cancelTitle} textSize='extra-large' textAlign='left'/>
            {this.props.order.isAutoRefill && 
            (<pui-stack mainaxisarrangement="start" secondaryaxisarrangement="start" spacingTop="medium" direction='horizontal'>
                <pui-section spacingTop="mini" spacingRight="small" style={{'width':'5%', 'max-width':'5%'}}>
                <pui-icon imgClass="status-warning-icon"></pui-icon>
                </pui-section>
                <pui-stack pui-stack direction='vertical'>
                <pui-text input={this.props.order.orderDetailPageLabels.cancelForm.cancelFormTitle} fontWeight="bold"></pui-text>
                <pui-text input={this.props.order.orderDetailPageLabels.cancelForm.cancelFormMessage}  textAlign='left'/>
                </pui-stack>
             </pui-stack>)
             }
            <pui-selector spacingBottom="medium" spacingTop="medium" multiselect ref={this.state.selectorRef} style={{ width: '100%' }}>
                {this.props.order.items.map((item, i) => <CancelFormSelect selectButton={(disable: boolean) => this._selectItem(disable)} key={`cancel-list-item-${i}`} item={item} isAutoRefill={this.props.order.isAutoRefill} />)}
            </pui-selector>

            {showCancelDrop && <pui-section style={{ width: '100%' }}>
                <CancellationDropdown
                
                        label={`${cancelReason.cancelReasonLabel}`}
                        placeHolderLabel={`${cancelReason.cancelReasonSelectLabel}`}
                        onSelectionChange={(newValue) => this.setCancelReason(newValue)}
                        selectedOption={this.state.cancelFilterOption}
                        >
                        {cancelReason.cancelReasonFilterOptions.map((filterOption) => (
                            <CancellationDropdownItem key={filterOption.value} filterOption={filterOption}/>
                        ))}
                </CancellationDropdown>
            </pui-section>}
            {button}
        </pui-stack>
        )
    }

    _selectItem(disableButton: boolean) {
        this.setState({ disableButton });
    }

    _onSubmit() {
        const cancelReason = this.state.cancelFilterOption ? `${this.state.cancelFilterOption?.value}` : null;
        const actionMetricsPublisher = appMetrics.getMetricsPublisherForMethod("CancelOrder");
        const attemptMetric = new KatalMetrics.Metric.TimedAttempt(MetricsConstants.METRIC_CANCEL_ORDER_REQUEST).withMonitor();

        this.setState({
            alert: false,
            disableButton: true,
        });

        const { orderId, purchaseId, csrf } = this.props.order;
        cancelOrder(purchaseId, orderId, cancelReason, csrf)
            .then((response: any) => {
                if ("CANCEL_PENDING" === response.cancellationStatus) {
                    this.setState({
                        alert: <pui-box spacingBottom="small" style={{ width: '85%' }} theme="solid">
                            <pui-text input={this.props.order.orderDetailPageLabels.cancelForm.cancelPending} />
                        </pui-box>
                    });
                    if (this.props.order.isAutoRefill) {
                        this.setState({
                            alert: <Redirect to={{
                                    pathname: '/',
                                    state: { orderHistoryRedirectionComponentRow: <OrderHistoryRedirectionComponentRow isRedirected={true} redirectionMessage={this.props.order.orderDetailPageLabels.redirectCancellationMessages.cancellationPendingAutoRefillRedirectMessage} redirectionTitle={this.props.order.orderDetailPageLabels.redirectCancellationMessages.cancellationPendingAutoRefillRedirectTitle}></OrderHistoryRedirectionComponentRow> }
                                    }}/>
                        })
                    }
                    if (this.props.refresh) {
                        this.props.refresh();
                    }
                } else {
                    if (this.props.order.isAutoRefill) {
                        this.setState({
                            alert: <Redirect to={{
                                    pathname: '/',
                                    state: { orderHistoryRedirectionComponentRow: <OrderHistoryRedirectionComponentRow isRedirected={true} redirectionMessage={this.props.order.orderDetailPageLabels.redirectCancellationMessages.cancellationSuccessAutoRefillRedirectMessage} redirectionTitle={this.props.order.orderDetailPageLabels.redirectCancellationMessages.cancellationSuccessRedirectTitle}></OrderHistoryRedirectionComponentRow>}
                                    }}/>
                        })
                    }
                    else {
                        this.setState({
                            alert: <pui-box spacingBottom="small" style={{ width: '85%' }} theme="success">
                                <pui-text input={this.props.order.orderDetailPageLabels.cancelForm.cancelSuccess} />
                            </pui-box>
                        })
                    }
                }
                attemptMetric.setSuccess();
                actionMetricsPublisher.publish(attemptMetric);
            })
            .catch(() => {
                this.setState({
                    alert: <pui-box style={{ width: '85%' }} theme="alert">
                        <pui-text input={this.props.order.orderDetailPageLabels.cancelForm.cancelFailed} />
                    </pui-box>
                });
                attemptMetric.setFailure();
                actionMetricsPublisher.publish(attemptMetric);
            });
        
    }
}


CancelForm.contextType = I18NContext;

export default CancelForm;